const getSiteIdRecreate = (rootState) => rootState.sites.siteIdRecreate;

export default getSiteIdRecreate;
